var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deck-thumb flex-row align-center center",style:(_vm.styleObj)},[_c('SlideFrame',{attrs:{"theme":_vm.deck.themeData,"showLogo":false,"options":_vm.firstSlide.options}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }